"use client";

import * as React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface FormErrorProps {
  message?: string;
}

export function FormError({ message }: FormErrorProps) {
  if (!message) {
    return null;
  }

  return (
    <Alert variant="destructive" className="mb-2">
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}